import { AxiosError } from 'axios';
import CustomAxios from './customAxios';

type DownloadCsvParams<FilterParam, SortParam> = {
  search?: string;
  filters?: FilterParam;
  sort?: SortParam;
};

type Controller = 'accounts' | 'events' | 'contacts' | 'employees' | 'tasks';

type DownloadCsvProps<FilterParam, SortParam> = {
  params?: DownloadCsvParams<FilterParam, SortParam>;
  controller: Controller;
};

const CSV_FILENAME_REGEX = /filename="(.+?)"/;

const getFilenameFromHeader = (dispositionHeader: string | undefined, controller: Controller): string => {
  const defaultFileName = `${controller}-report.csv`;
  if (!dispositionHeader) return defaultFileName;

  const matches = CSV_FILENAME_REGEX.exec(dispositionHeader);

  if (matches != null && matches[1]) {
    return matches[1].replace(/['"]/g, '');
  }
  return defaultFileName;
};

async function downloadCsv<FilterParam, SortParam>({ params, controller }: DownloadCsvProps<FilterParam, SortParam>) {
  const response = await CustomAxios.get(`${controller}`, {
    params,
    headers: {
      Accept: 'text/csv',
    },
    responseType: 'blob',
  });

  const filename = getFilenameFromHeader(response.headers['content-disposition'], controller);

  const blob = new Blob([response.data], { type: 'text/csv' });
  const downloadUrl: string = window.URL.createObjectURL(blob);
  const link = document.createElement('a');

  link.href = downloadUrl;
  link.setAttribute('download', filename);

  document.body.appendChild(link);

  link.click();
  link.remove();

  window.URL.revokeObjectURL(downloadUrl);
}

function handleDownloadCsvError(error: AxiosError) {
  if (error?.response?.status === 400) {
    console.error('CSV Download failed', error.message);
    alert('Failed to download report. Please try again.');
  } else {
    console.error('An unexpected error occurred', error);
    alert('An unexpected error occurred.');
  }
}

export {
  // types
  type DownloadCsvProps,

  // methods
  downloadCsv,
  handleDownloadCsvError,
};
